import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { Field } from "../../../models/field.model";
import { DashboardDataProvider } from "../../../data-provider/dashboard.dp";
import { DashboardWidget } from "../../../models/dashboard-widget.model";
import { Dashboard } from "../../../models/dashboard.model";
import { CanvassStatus } from "../../../models/canvass-status.model";

let DuplicateWidgetComponent = {
    selector: "vcDuplicateWidget",
    templateUrl:
        "/angular/components/dashboard/widget/duplicate-widget.component.html",
    bindings: {
        widget: "=",
    },
    controller: class DuplicateWidgetController {
        public dashboard: Dashboard;
        public accessType: string | number;
        public name: string;
        public step: number = 1;
        public customFields: Field[];

        public canvassStatuses: CanvassStatus[];
        public widget: DashboardWidget = new DashboardWidget();
        private dialog: DialogUtils;
        private dataProvider: DashboardDataProvider;

        public saving: boolean = false;

        constructor(
            DialogUtils: DialogUtils,
            DashboardDataProvider: DashboardDataProvider
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = DashboardDataProvider;
        }

        confirm(): void {
            this.saving = true;
            this.dataProvider.createWidget(this.widget).then(
                (widget: any): void => {
                    this.dialog.hide(widget);
                },
                (error: any): void => {
                    this.saving = false;
                }
            );
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dashboard")
    .component(DuplicateWidgetComponent.selector, DuplicateWidgetComponent);
